import { createSelector } from 'reselect';
import { createConfigSelector } from '@americanexpress/travel-selectors';

export const getIZDomainsSelector = createConfigSelector('IzHotelDomain');

export const getEwpDomainSelector = createConfigSelector('ewpDomain');

export const getHotelDeepLinksUrl = ({
  hotelId,
  tripStartDate,
  tripEndDate,
  hotelRoomType,
  noOfRooms = '1',
  noOfAdults = '2',
}) => (state) => `${getIZDomainsSelector(state)}/hotel_detail?hotel_id=${hotelId}&start_date=${tripStartDate}&end_date=${tripEndDate}&num_rooms=${noOfRooms}&number_adults=${noOfAdults}&partner_program=${hotelRoomType}`;

export const getKytContextApiUrlSelector = createSelector(
  getEwpDomainSelector,
  (ewpDomain) => `${ewpDomain}/travel/v2/kyt/context/inquiry_results`
);

export const kytClearContextApiUrlSelector = createSelector(
  getEwpDomainSelector,
  (ewpDomain) => `${ewpDomain}/travel/v2/kyt/context/clear`
);

export const postKytContextFeedbackApiUrlSelector = createSelector(
  getEwpDomainSelector,
  (ewpDomain) => `${ewpDomain}/travel/v2/kyt/feedback`
);
